import {
  Box,
  Stack,
  Typography,
  Link,
  Divider,
} from "@mui/material";
import { useMediaQuery } from '@mui/material';
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from '@mui/icons-material/X';
import CusAccordion from "./CusAccordion";

function FooterIndustry({ ourProducts, bg, color }) {

  
  // const isSmallScreen = useMediaQuery('(max-width:600px)');//mobile
  // const isMediumScreen = useMediaQuery('(min-width:601px) and (max-width:1000px)');//tab
  // const isLargeScreen = useMediaQuery('(min-width:1001px)');//lap
  // const isBetweenScreen = useMediaQuery('(min-width:1535px) and (max-width:1700px)');//lap and xl
  // const isExtraLargeScreen = useMediaQuery('(min-width:1701px)');
  // const sx = {
  //   columnGap: ["2rem", "2rem", "2rem", "2rem", "2rem"],
  //   gap: "0rem",
  //   flexDirection: isSmallScreen ? 'column' :
  //                   isMediumScreen ?'row':
  //                   isLargeScreen ?'row':
  //                   isBetweenScreen?'column':
  //                   isExtraLargeScreen?'row':'row',
  //   flexWrap: isMediumScreen ? 'wrap' : 'nowrap',
  // };

  const overview = [
    {
      path: "/",
      name: "Home",
    },
    {
      path: "/about",
      name: "About",
    },
    {
      path: "/services",
      name: "Services",
    },
    {
      path: "/industries",
      name: "Industries",
    },
    {
      path: "/contact-us",
      name: "Contact Us",
    },

    {
      path: "/privacy-policies",
      name: "Privacy",
    },

    {
      path: "/terms-and-conditions",
      name: "Terms & Conditions",
    },
    
  ];

  
  return (
    <>
      <Box
        sx={{
          width: "100%",
          bgcolor: bg ?? "#0B1829",
          display: "flex",
          flexDirection: "column",
          gap: ["1rem", "1.2rem", "1.8rem", "2rem", "3rem"],
          py: ["1rem", "1.2rem", "1.8rem", "2rem"],
          pt: [3, 3, 7, 6],
          px: ["1rem", "2.2rem", "0", "3rem", 12],
          color: "#fff",
          "& *": {
            fontFamily: "'Roboto', sans-serif !important",
          },
        }}
      >
        <Stack
          sx={{
            columnGap: ["2rem", "2rem", "2rem", "2rem", "2rem"],
            gap: "0rem",
          flexWrap:['wrap','wrap','nowrap']
          }}
          direction={{ xs: "column", sm: "row",md:'row',lg:'row',xl:'row' }}
          gap={{ xs: 2, sm: 3, md: 1 }}
          flexWrap={{ sm: "wrap" }}
          justifyContent={{
            xs: "space-between",
            sm: "center",
            md: "center",
            lg: "space-between",
            xl:"space-around",
          }}
        >
          {/* Address */}

          <CusAccordion
            display={["flex", "flex", "none"]}
            head={
              <Typography
                sx={{
                  fontSize: ["1rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                Address
              </Typography>
            }
            body={
              <Stack
                direction="column"
                width={{ xs: "100%", sm: "auto" }}
                gap={{ xs: 0.5, sm: 1 }}
              >
                <Stack
                  direction="column"
                  width={{ xs: "100%", sm: "auto" }}
                  gap={{ xs: 0, sm: 0.7 }}
                >
                  <Typography
                    sx={{
                      fontSize: [".85rem", ".85rem", "12px", "12px", ".85rem"],
                      fontWeight: 600,
                      color: color ?? "#6897E4",
                    }}
                  >
                    India
                  </Typography>
                  <Stack
                    direction="column"
                    width={{ xs: "100%", sm: "auto" }}
                    gap={{ xs: 1, sm: 1 }}
                  >
                    <Typography
                      sx={{
                        fontSize: [
                          ".85rem",
                          ".85rem",
                          "12px",
                          "12px",
                          ".85rem",
                        ],
                      }}
                    >
                      Thanjavur <br />
                      6/12 Papa vaikal Street Ayyampettai <br />
                      Papanasam Thanjavur
                      <br />
                      Tamilnadu India.
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction="column"
                  width={{ xs: "100%", sm: "auto" }}
                  gap={{ xs: 0, sm: 0.7 }}
                >
                  <Typography
                    sx={{
                      fontSize: [".85rem", ".85rem", "12px", "12px", ".85rem"],
                      fontWeight: 600,
                      color: color ?? "#6897E4",
                    }}
                  >
                    United Kingdom
                  </Typography>
                  <Stack
                    direction="column"
                    width={{ xs: "100%", sm: "auto" }}
                    gap={{ xs: 1, sm: 1 }}
                  >
                    <Typography
                      sx={{
                        fontSize: [
                          ".85rem",
                          ".85rem",
                          "12px",
                          "12px",
                          ".85rem",
                        ],
                      }}
                    >
                      London
                      <br />
                      71-75 Shelton Street, Covent Garden,
                      <br />
                      London, WC2H 9JQ, United Kingdom.
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="column"
                  width={{ xs: "100%", sm: "auto" }}
                  gap={{ xs: 0, sm: 0.7 }}
                >
                  <Typography
                    sx={{
                      fontSize: [".85rem", ".85rem", "12px", "12px", ".85rem"],
                      fontWeight: 600,
                      color: color ?? "#6897E4",
                    }}
                  >
                    Contact us
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: [".85rem", ".85rem", "12px", "12px", ".85rem"],
                      ":hover": {
                        color: color ?? "#6897E4",
                      },
                    }}
                  >
                    <Link
                      color={"inherit"}
                      underline="hover"
                      href="mailto:contact@aattralsupremacy.com"
                    >
                      contact@techbrainnetworks.com
                    </Link>
                  </Typography>
                </Stack>
              </Stack>
            }
          />

          <Stack
            direction="column"
            width={{ xs: "100%", sm: "auto" }}
            gap={{ xs: 0.5, sm: 1 }}
            sx={{
              display: ["none", "none", "flex"],
            }}
          >
            <Typography
              sx={{
                fontSize: ["1.5rem", ".85rem", "20px", "25px", "2rem"],
                letterSpacing:2,
                fontWeight: 600,
                color: color ?? "#6897E4",
              }}
            >
              Address
            </Typography>
            <Stack
              direction="column"
              width={{ xs: "100%", sm: "auto" }}
              gap={{ xs: 0, sm: 0.5 }}
            >
              <Typography
                sx={{
                  fontSize: ["1.5rem", ".85rem", "12px", "15px", "1.5rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                India
              </Typography>
              <Stack
                direction="column"
                width={{ xs: "100%", sm: "auto" }}
                gap={{ xs: 1, sm: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: ["1.2rem", ".85rem", "12px", "15px", "1.2rem"],
                  }}
                >
                  Thanjavur <br />
                  6/12 Papa vaikal Street Ayyampettai <br />
                  Papanasam Thanjavur
                  <br />
                  Tamilnadu India.
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction="column"
              width={{ xs: "100%", sm: "auto" }}
              gap={{ xs: 0, sm: 0.7 }}
            >
              <Typography
                sx={{
                  fontSize: ["1.5rem", ".85rem", "12px", "15px", "1.5rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                United Kingdom
              </Typography>
              <Stack
                direction="column"
                width={{ xs: "100%", sm: "auto" }}
                gap={{ xs: 1, sm: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: ["1.2rem", ".85rem", "12px", "15px", "1.2rem"],
                  }}
                >
                  London
                  <br />
                  71-75 Shelton Street, Covent Garden,
                  <br />
                  London, WC2H 9JQ, United Kingdom.
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction="column"
              width={{ xs: "100%", sm: "auto" }}
              gap={{ xs: 0, sm: 0.7 }}
            >
              <Typography
                sx={{
                  fontSize: ["1.5rem", ".85rem", "12px", "15px", "1.5rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                Contact us
              </Typography>
              <Typography
                sx={{
                  fontSize: ["1.2rem", ".85rem", "12px", "15px", "1.2rem"],
                  ":hover": {
                    color: color ?? "#6897E4",
                  },
                }}
              >
                <Link
                  color={"inherit"}
                  underline="hover"
                  href="mailto:contact@aattralsupremacy.com"
                >
                  contact@techbrainnetworks.com
                </Link>
              </Typography>
            </Stack>
          </Stack>
          {/* Products */}

          <CusAccordion
            display={["flex", "flex", "none"]}
            head={
              <Typography
                sx={{
                  fontSize: ["1rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                Products
              </Typography>
            }
            body={
              <Stack direction={{ xs: "row" }} gap={{ xs: 1.2, sm: 4 }}>
                <Stack direction={{ xs: "column" }} gap={{ xs: 1.2, sm: 2 }} >
                  {ourProducts.slice(0, 10).map((item, index) => (
                    <Typography
                      key={index}
                      component={Link}
                      href={item.link}
                      color={"inherit"}
                      underline="hover"
                      sx={{
                        fontSize: [
                          ".85rem",
                          ".85rem",
                          "12px",
                          "12px",
                          ".85rem",
                        ],
                        ":hover": {
                          color: color ?? "#6897E4",
                          textDecoration:'none',
                        },
                      }}
                    >
                      {item.title}
                    </Typography>
                  ))}
                </Stack>

                <Stack direction={{ xs: "column" }} gap={{ xs: 1.2, sm: 2 }}>
                  {ourProducts.slice(10, 21).map((item, index) => (
                    <Typography
                      key={index}
                      component={Link}
                      href={item.link}
                      color={"inherit"}
                      underline="hover"
                      sx={{
                        fontSize: [
                          ".85rem",
                          ".85rem",
                          "12px",
                          "12px",
                          ".85rem",
                        ],
                        ":hover": {
                          color: color ?? "#6897E4",
                          textDecoration:'none',
                        },
                      }}
                    >
                      {item.title}
                    </Typography>
                  ))}
                </Stack>
              </Stack>
            }
          />

          <CusAccordion
            display={["flex", "flex", "none"]}
            head={
              <Typography
                sx={{
                  fontSize: ["1rem"],
                  fontWeight: 600,
                  color: color ?? "#6897E4",
                }}
              >
                Overview
              </Typography>
            }
            body={
              <Stack direction={{ xs: "column" }} gap={{ xs: 1.2, sm: 2 }}>
                {overview.slice(0, 10).map((item, index) => (
                  <Typography
                    key={index}
                    component={Link}
                    href={item.path}
                    color={"inherit"}
                    underline="hover"
                    sx={{
                      fontSize: [".85rem", ".85rem", "12px", "12px", ".85rem"],
                      ":hover": {
                        color: color ?? "#6897E4",
                        textDecoration:'none',
                      },
                    }}
                  >
                    {item.name}
                  </Typography>
                ))}
              </Stack>
            }
          />
          <Box
            display="flex"
            flexDirection={{ xs: "column" }}
            alignItems={{ xs: "flex-start" }}
            gap={{ xs: 0.5, sm: 1 }}
            color="#fff"
            sx={{
              display: ["none", "none", "flex"],
            }}
          >
            <Typography
              sx={{
                fontSize: ["1.5rem", ".85rem", "20px", "25px", "2rem"],
                letterSpacing:2,
                fontWeight: 600,
                color: color ?? "#6897E4",
                // mt:['0rem','0rem','0rem','4rem','0rem']
              }}
            >
              Products
            </Typography>
            <Stack direction={{ xs: "row",sm:"row",md:"row",lg:"row",xl:"row" }}gap={{ xs: 1.2, sm: 4 }} >
              <Stack direction={{ xs: "column" }} gap={{ xs: 1.2, sm: 2 }}>
                {ourProducts.slice(0, 10).map((item, index) => (
                  <Typography
                    key={index}
                    component={Link}
                    href={item.link}
                    color={"inherit"}
                    underline="hover"
                    sx={{
                      fontSize: ["1.2rem", ".85rem", "12px", "15px", "1.2rem"],
                      ":hover": {
                        color: color ?? "#6897E4",
                        textDecoration:'none',  
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                ))}
              </Stack>

              <Stack direction={{ xs: "column"}} gap={{ xs: 1.2, sm: 2 }}>
                {ourProducts.slice(10, 21).map((item, index) => (
                  <Typography
                    key={index}
                    component={Link}
                    href={item.link}
                    color={"inherit"}
                    underline="hover"
                    sx={{
                      fontSize: ["1.2rem", ".85rem", "12px", "15px", "1.2rem"],
                      ":hover": {
                        color: color ?? "#6897E4",
                        textDecoration:'none',
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                ))}
              </Stack>
            </Stack>
          </Box>
        </Stack>

        <Box
      sx={{
        background: `linear-gradient(to right, transparent, ${color ?? '#6897E4'}, transparent)`,
        my: 2, // Equivalent to Tailwind's my-8
        height: '1px',
        width: '100%'
      }}
    />

        <Stack
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            width: "100%",
            gap: 3,
          }}
        >
           <Typography
              sx={{
                fontSize: ["1.2rem", "1.2rem", "20px", "25px", "2.5rem"],
                color: color ?? "#6897E4",
                fontWeight: 600,
                mt: "1rem",
                letterSpacing:3,
              }}
            >
              TECHBRAIN 
              NETWORKS
            </Typography>
          <Stack direction={{ xs: "row" }} gap={{ xs: 1, md: 2 }}>
            <Link href="https://www.linkedin.com/company/techbrain-networks/" color="inherit" underline="none">
              <LinkedInIcon
                sx={{
                  fontSize: ["1.4rem", "1.6rem", "1.7rem", "1.8rem", "2.5rem"],
                  ":hover": {
                    color: color ?? "#6897E4",
                  },
                }}
              />
            </Link>
            <Link href="" color="inherit" underline="none">
              <FacebookIcon
                sx={{
                  fontSize: ["1.4rem", "1.6rem", "1.7rem", "1.8rem", "2.5rem"],
                  ":hover": {
                    color: color ?? "#6897E4",
                  },
                }}
              />
            </Link>
            <Link href="" color="inherit" underline="none">
              <XIcon
                sx={{
                  fontSize: ["1.4rem", "1.6rem", "1.7rem", "1.8rem", "2.2rem"],
                  ":hover": {
                    color: color ?? "#6897E4",
                  },
                }}
              />
            </Link>
            <Link href="" color="inherit" underline="none">
              <InstagramIcon
                sx={{
                  fontSize: ["1.4rem", "1.6rem", "1.7rem", "1.8rem", "2.5rem"],
                  ":hover": {
                    color: color ?? "#6897E4",
                  },
                }}
              />
            </Link>
          </Stack>
          {/* overview */}
          <Stack
            direction={"row"}
            justifyContent={"center"}
            sx={{
              flexWrap: "wrap",
              width: ["55%", "95%", "75%", "55%", "55%"],
              gap: 2,
              display: ["none", "none", "flex"],
            }}
          >
            {overview.map((i, e) => (
              <>
                {e === 0 ? null : (
                  <Divider
                    orientation="vertical"
                    color="#fff"
                    variant="middle"
                    flexItem
                  />
                )}
                <Typography
                  key={e}
                  component={Link}
                  href={i.path}
                  color="inherit"
                  underline="none"
                  aria-label={i.name}
                  sx={{
                    fontSize: ["1.5rem", ".85rem", "15px", "20px", "1.5rem"],
                    "&:hover": {
                      color: color ?? "#6897E4",
                    },
                  }}
                >
                  {i.name}
                </Typography>
              </>
            ))}
          </Stack>
        </Stack>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            color={"inherit"}
            underline="hover"
            sx={{
              fontSize: ["1rem", ".75rem", "12px", "15px", "1.3rem"],
              color: "#f6f6f6",
              textAlign: "center",
            }}
          >
            © {new Date().getFullYear()} Techbrain Networks. All Rights Reserved.
          </Typography>
        </Stack>
      </Box>
    </>
  );
}

export default FooterIndustry;
